import { render, staticRenderFns } from "./FaqsElmwood.vue?vue&type=template&id=659eff2c"
import script from "./FaqsElmwood.vue?vue&type=script&lang=js"
export * from "./FaqsElmwood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports